import type { RouteRecordRaw } from 'vue-router'

const meetingsRoutes: RouteRecordRaw[] = [
  {
    path: '/office/meetings',
    name: 'meetings.index',
    component: () => import('@/modules/meetings/views/MeetingsIndex.vue'),
    meta: {
      pageTitle: 'Meetings',
      breadcrumbs: ['Meetings']
    }
  },
  {
    path: '/office/meetings/create',
    name: 'meetings.create',
    component: () => import('@/modules/meetings/views/MeetingsCreate.vue'),
    meta: {
      pageTitle: 'Create Meeting',
      breadcrumbs: ['Meetings', 'Create']
    }
  },
  {
    path: '/office/meetings/:id/minutes',
    name: 'meetings.minutes.edit',
    component: () => import('@/modules/meetings/views/MeetingsMinutesEdit.vue'),
    meta: {
      pageTitle: 'Edit Minutes',
      breadcrumbs: ['Meetings', 'Minutes']
    }
  },
  {
    path: '/office/meetings/:id',
    name: 'meetings.show',
    component: () => import('@/modules/meetings/views/MeetingsShow.vue'),
    meta: {
      pageTitle: 'Meeting show',
      breadcrumbs: ['Meetings', 'Show']
    }
  }
]

export default meetingsRoutes
